import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2FolderOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M6 26V10h20v14h2V8h-9.086l-4-4H4v24h22.6l1.4-2zM6 6h8.086l2 2H6z" /></svg>
);
